import { render, staticRenderFns } from "./FiltersFieldItem.vue?vue&type=template&id=1507bae9&scoped=true"
import script from "./FiltersFieldItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltersFieldItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FiltersFieldItem.vue?vue&type=style&index=0&id=1507bae9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1507bae9",
  null
  
)

export default component.exports